export default class Client {
  constructor(API) {
    this.api = API;
  }
  async createClient(clientName) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/client/new';
    req.body = { name: clientName };
    return await req.exec();
  }
  async updateClient(clientName, clientID) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/client/' + clientID;
    req.body = { name: clientName };
    return await req.exec();
  }
  async deleteClient(clientID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/client/' + clientID;
    return await req.exec();
  }
  async getClient(clientID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/client/' + clientID;
    return await req.exec();
  }
  async getAllClient() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/clients';
    return await req.exec();
  }
}
